import React, { createContext, useContext, useEffect, useState } from "react";
import { log } from "@/lib/logger";

const WishCtx = createContext(null);
const STORAGE_KEY = "bhola_wishlist_v1";

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (err) {
      log.error("[WishlistContext] read failed", err);
    }
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (err) {
      log.error("[WishlistContext] write failed", err);
    }
  }, [items]);

  const has = (tag_no) => items.some((i) => i.tag_no === tag_no);
  const toggle = (item) => {
    setItems((cur) => (cur.some((i) => i.tag_no === item.tag_no)
      ? cur.filter((i) => i.tag_no !== item.tag_no)
      : [...cur, { tag_no: item.tag_no, item_name: item.item_name, image_path: item.image_path, karat: item.karat, gold_weight: item.gold_weight, diamond_weight: item.diamond_weight }]
    ));
  };
  const remove = (tag_no) => setItems((cur) => cur.filter((i) => i.tag_no !== tag_no));
  const clear = () => setItems([]);

  return (
    <WishCtx.Provider value={{ items, has, toggle, remove, clear, open, setOpen, count: items.length }}>
      {children}
    </WishCtx.Provider>
  );
};

export const useWishlist = () => useContext(WishCtx);
